import React, { Component } from 'react';
import { message, Menu, Dropdown, Button } from 'antd';
import axios from 'axios'
import './rewriteDropdown.scss'

const { SubMenu } = Menu;
const BASE_API = ''

// 归类button 组件
class RewriteDropdown extends Component {
    state = {
        menuData: []
    }
    componentDidMount() {
        this.getMenuData()
    }
    getMenuData = () => {
        const { report } = this.props
        axios({
            method: 'get',
            url: `${BASE_API}/api/lossAss/report/materialsTypes`,
            params: {
                flowId: report.flowId,
            },
        }).then(res => {
            if (res.data.errCode === 0) {
                const menus = res.data.result || [];
                menus.push({
                    label: '本地',
                    value: 'Local',
                    secondTypes: [
                        {
                            label: '其他',
                            value: 'localEtc'
                        }
                    ]
                })
                this.setState({ menuData: menus, })

            } else {
                message.error(res.data.errInfo)
            }

        }).catch(err => {

        })
    }
    render() {
        const { menuData } = this.state
        const { report, classifyPics, children } = this.props
        const menu = (
            <Menu>
                <SubMenu title={report.ownCarLoss.carOwner} key={report.ownCarLoss._id}>
                    {
                        menuData.map(firstData =>
                            <SubMenu
                                key={`${report.ownCarLoss._id}_${firstData.value}`}
                                title={firstData.label}
                            >
                                {
                                    firstData.secondTypes.map(secondData => <Menu.Item
                                        key={`${report.ownCarLoss._id}_${firstData.value}_${secondData.value}`}
                                    >
                                        <a
                                            className="ant-dropdown-link"
                                            href="#"
                                            onClick={() => classifyPics(report.ownCarLoss._id, firstData.value, '', secondData.value)}
                                        >
                                            {secondData.label}
                                        </a>

                                    </Menu.Item>)
                                }

                            </SubMenu>)

                    }
                </SubMenu>
                {
                    report && report.otherCarLoss && report.otherCarLoss.length > 0 &&
                    report.otherCarLoss.map(car =>
                        <SubMenu title={car.carOwner} key={car._id}>
                            {
                                menuData.map(firstData =>
                                    <SubMenu
                                        key={`${car._id}_${firstData.value}`}
                                        title={firstData.label}
                                    >
                                        {
                                            firstData.secondTypes.map(secondData => <Menu.Item
                                                key={`${car._id}_${firstData.value}_${secondData.value}`}
                                            >
                                                <a
                                                    className="ant-dropdown-link"
                                                    href="#"
                                                    onClick={() => classifyPics(car._id, firstData.value, '', secondData.value)}
                                                >
                                                    {secondData.label}
                                                </a>

                                            </Menu.Item>)
                                        }

                                    </SubMenu>)

                            }
                        </SubMenu>

                    )
                }

            </Menu>
        )



        return (
            <div>
                <Dropdown
                    overlayClassName='rewrite-dropdown'
                    overlay={menu}
                    placement={'topLeft'}
                    trigger={'click'}
                >
                    <Button>移动</Button>
                </Dropdown>
            </div>
        );
    }
}

export default RewriteDropdown;
